import Damai from "assets/images/logos/damai.png";
import bebit from "assets/images/logos/bebit.png";
import Feng from "assets/images/logos/feng.png";
import Lidemy from "assets/images/logos/lidemy.png";

import figma from "assets/images/skills/figma.png";
import vscode from "assets/images/skills/vscode.png";
import react from "assets/images/skills/react.png";
import javascript from "assets/images/skills/javascript.png";
import typescript from "assets/images/skills/typescript.png";
import html5 from "assets/images/skills/html-5.png";
import css3 from "assets/images/skills/css3.png";
import mysql from "assets/images/skills/mysql.png";
import firestore from "assets/images/skills/firestore.png";
import mongodb from "assets/images/skills/mongodb.png";

export const companies = [
  {
    title: "beBit TECH, Inc.",
    alt: "beBit image",
    role: "Frontend developer",
    skills: [
      "ReactJS",
      "React Native",
      "TypeScript",
      "Javascript",
      "Ant Design",
    ],
    period: "2022.08 - Present",
    startingYear: "2022",
    logo: bebit,
  },
  {
    title: "DAMAI internet Inc.",
    alt: "Damai image",
    role: "Frontend developer",
    skills: [
      "ReactJS",
      "Svelte",
      "VueJS",
      "TypeScript",
      "NodeJS",
      "Chakra UI",
      "Vite"
    ],
    period: "2021.02 - 2022.07",
    startingYear: "2021",
    logo: Damai,
  },
];

export const institutes = [
  {
    short_title: "Lidemy mentor-program-4th",
    title: "Graduate",
    alt: "Lidemy",
    role: "self learning web development",
    skills: ["project management", "web development", "data structures"],
    period: "2020.06 - 2020.12",
    startingYear: "2020",
    logo: Lidemy,
    awards: [
      {
        title: "JUMBO HOME DECO. CORPORATION TAIWAN BRANCH",
        description: "Sales assistant",
        date: "2017.12 - 2020.02",
      },
      {
        title: "Glory Transwell Corp",
        description: "Sales assistant",
        date: "2016.12 - 2017.10",
      }
    ],
  },
  {
    short_title: "Feng Chia University",
    title: "Bachelor of Business in International Trade",
    alt: "college image",
    role: "Business in International Trade",
    skills: ["Business", "International Trade"],
    period: "2012 - 2016.06",
    startingYear: "2012",
    logo: Feng,
  },
];

export const skills = [
  {
    name: "React",
    description: "Web development",
    link: "https://reactjs.org/",
    type: "development",
    image: react,
  },

  {
    name: "Javascript",
    description: "Web development",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    type: "development",
    image: javascript,
  },
  {
    name: "Typescript",
    description: "Web development",
    link: "https://www.typescriptlang.org/",
    type: "development",
    image: typescript,
  },
  {
    name: "Html5",
    description: "Web layouts",
    link: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5",
    type: "development",
    image: html5,
  },
  {
    name: "Css3",
    description: "Web design",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    type: "design",
    image: css3,
  },

  {
    name: "Mysql",
    description: "Database",
    link: "https://www.mysql.com/",
    type: "database",
    image: mysql,
  },
  {
    name: "MongoDB",
    description: "Database",
    link: "https://www.mongodb.com/",
    type: "database",
    image: mongodb,
  },
  {
    name: "FireStore",
    description: "Database",
    link: "https://cloud.google.com/firestore",
    type: "database",
    image: firestore,
  },

  {
    name: "Visual Studio Code",
    description: "Code editor of choice",
    link: "https://code.visualstudio.com/",
    type: "development",
    image: vscode,
  },
  {
    name: "Figma",
    description: "Collaborative Design",
    link: "https://www.figma.com/",
    type: "design",
    image: figma,
  },
];
